import apiClient from './client'
import { User } from '../types/auth'
import { ensureArray } from '../utils/array'

export interface CreateUserPayload {
  name: string
  email: string
  password: string
  is_active?: boolean
  nivel_acesso?: number | null
  descricao_superadmin?: string
  descricao_usuario?: string
}

export type UserSortField =
  | 'id'
  | 'name'
  | 'email'
  | 'nivel_acesso'
  | 'is_active'
  | 'login_thor'
  | 'iduser_thor'
  | 'created_at'
  | 'updated_at'

export const usuariosApi = {
  list: async (options?: {
    includeInactive?: boolean
    grupoId?: number | null
    empresaId?: number | null
    sort_by?: UserSortField
    sort_direction?: 'asc' | 'desc'
  }): Promise<User[]> => {
    const params: Record<string, unknown> = {
      limit: 1000,  // Aumentar limite para buscar todos os usuários
    }
    if (!options?.includeInactive) {
      params.is_active = true
    }
    if (options?.grupoId) {
      params.grupo_id = options.grupoId
    }
    if (options?.empresaId) {
      params.empresa_id = options.empresaId
    }
    if (options?.sort_by) {
      params.sort_by = options.sort_by
    }
    if (options?.sort_direction) {
      params.sort_direction = options.sort_direction
    }
    const response = await apiClient.get<User[]>('/usuarios', { params })
    return ensureArray<User>(response.data)
  },

  create: async (data: CreateUserPayload): Promise<User> => {
    const response = await apiClient.post<User>('/usuarios', {
      ...data,
      nivel_acesso: data.nivel_acesso ?? undefined,
    })
    return response.data
  },

  get: async (id: number): Promise<User> => {
    const response = await apiClient.get<User>(`/usuarios/${id}`)
    return response.data
  },

  update: async (id: number, data: Partial<User>): Promise<User> => {
    const response = await apiClient.put<User>(`/usuarios/${id}`, data)
    return response.data
  },

  vincularEmpresa: async (usuarioId: number, empresaId: number): Promise<void> => {
    await apiClient.post(`/usuarios/${usuarioId}/empresas/${empresaId}`)
  },

  desvincularEmpresa: async (usuarioId: number, empresaId: number): Promise<void> => {
    await apiClient.delete(`/usuarios/${usuarioId}/empresas/${empresaId}`)
  },

  alterarSenhaGalatea: async (usuarioId: number, novaSenha: string): Promise<void> => {
    await apiClient.post(`/usuarios/${usuarioId}/senha`, { nova_senha: novaSenha })
  },

  alterarSenhaThor: async (usuarioId: number, senhaThor: string): Promise<void> => {
    await apiClient.post(`/usuarios/${usuarioId}/senha-thor`, { senha_thor: senhaThor })
  },

  alterarAmbasSenhas: async (usuarioId: number, novaSenhaGalatea: string, senhaThor: string): Promise<void> => {
    await apiClient.post(`/usuarios/${usuarioId}/senhas`, {
      nova_senha_galatea: novaSenhaGalatea,
      senha_thor: senhaThor,
    })
  },
}


